import styled from 'styled-components';
import { Text14Light, Text15Bold, Text18Bold } from '../../components/utils/Text/Text.styles';

export const PageContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 60rem;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  background: linear-gradient(180deg, #1c1d1f 0%, #0f0f10 100%);
`;
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.6rem 1.6rem 3rem 1.6rem;
  overflow-y: auto;
  height: 100%;
`;

export const Title = styled(Text18Bold)`
  color: #fff;
  margin-bottom: 1.8rem;
`;

export const SectionTitle = styled(Text15Bold)`
  margin-bottom: 0.6rem;
  color: #fff;
`;

export const Paragraph = styled(Text14Light)`
  color: #fff;
  line-height: 2.2rem;
  opacity: 0.7;
  margin-bottom: 1.8rem;
`;
